import { inject, observer } from 'mobx-react';

import Moment from 'moment';
import React from 'react';
import { computed } from 'mobx';

@inject('vm')
@observer
class Subtitle extends React.Component {
  render() {
    if (!this.show) return null;
    return <h4>{this.label}</h4>;
  }

  @computed
  get show() {
    let { status, report } = this.props.vm;
    return status === 'normal' && !!report && !!report.timeStamp;
  }

  @computed
  get label() {
    let { timeStamp } = this.props.vm.report;
    return new Moment(timeStamp).format('dddd Do MMMM YYYY [at] h:mma');
  }
}

export default Subtitle;
